import * as React from 'react';
import PropTypes from 'prop-types';
import icons from '../../icons';
import {
  AlertIcon,
  AlertErrorIcon,
  AlertInfoIcon,
  AlertSuccessIcon,
  AlertWarningIcon,
  AlertIconRoot,
  LoadingWarningIcon,
} from './AlertIcon.style';

const DefaultAlertIcon = ({ type }) => {
  switch (type) {
    case 'error':
      return <AlertErrorIcon data-testid="error-icon" />;
    case 'info':
      return <AlertInfoIcon data-testid="info-icon" />;
    case 'announcement':
      return <icons.Announcement data-testid="announcement-icon" />;
    case 'success':
      return <AlertSuccessIcon data-testid="success-icon" />;
    case 'warning':
      return <AlertWarningIcon data-testid="warning-icon" />;
    case 'loading':
      return <LoadingWarningIcon size={18} data-testid="loading-icon" />;
    default:
      return null;
  }
};

const AlertIconComponent = ({ type }) => {
  const defaultIcon = <DefaultAlertIcon type={type} />;

  if (!defaultIcon) {
    return null;
  }

  return (
    <AlertIconRoot>
      <AlertIcon>{defaultIcon}</AlertIcon>
    </AlertIconRoot>
  );
};

AlertIconComponent.propTypes = {
  // The type that defines the default icon
  type: PropTypes.oneOf([
    'custom',
    'error',
    'info',
    'success',
    'warning',
    'loading',
    'announcement',
  ]),
};

AlertIconComponent.defaultProps = {
  type: 'custom',
};

export default AlertIconComponent;
